// Borrowed from: https://gist.github.com/codeguy/6684588

const slugify = (str: string | number): string | number => {
  if (typeof str !== "string") return str;

  let slug = str;
  slug = slug.replace(/^\s+|\s+$/g, ""); // trim
  slug = slug.toLowerCase();

  // remove accents, swap ñ for n, etc
  const from = "àáäåâèéëêìíïîòóöôùúüûñç·/_,:;";
  const to = "aaaaaeeeeiiiioooouuuunc------";
  for (let i = 0, l = from.length; i < l; i++) {
    slug = slug.replaceAll(from.charAt(i), to.charAt(i));
  }

  slug = slug
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-"); // collapse dashes

  return slug;
};
export default slugify;
